import Icon, { IconProps } from './Icon';

import EditDocIcon from '../../../assets/icons/edit-05.svg?react';

const EditDoc: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <EditDocIcon />
    </Icon>
  );
};

export default EditDoc;
